import React, {useEffect, useState} from 'react';
import * as moment from 'moment';
import './Dashboard.scss';
import {navigate} from "@reach/router";
import routes from '../../utils/api-client';
import Button from "@material-ui/core/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {OWNER, purposeMapping} from "../../config/constants";
import * as _ from "lodash";
import {connect} from "react-redux";
import {toggleAccountPreferencesModal, toggleLoading} from "../../redux/reducers/utils";
import {compose} from "redux";
import Paper from "@material-ui/core/Paper";
import VaultCard from "./components/VaultCard";
import ActivityLog from "./ActivityLog/ActivityLog";
import DashboardBanner from "./components/DashboardBanner";
import Checkbox from "@material-ui/core/Checkbox";
import FreeTrialCard from "./components/FreeTrialCard";
import useWindowDimensions from "../../utils/helpers";

function Dashboard(props) {
  let [vaults, setVaults] = useState(null);
  let [showOwnerArchived, setShowOwnerArchived] = useState(false);
  let [showOtherArchived, setShowOtherArchived] = useState(false);
  let [activityLog, setActivityLog] = useState([]);
    let [vaultBuffer, setVaultBuffer] = useState(1);
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    if (width < 570) {
      setVaultBuffer(1);
    } else if (width < 792) {
      setVaultBuffer(2);
    } else if (width < 1024) {
      setVaultBuffer(3);
    } else if (width < 1124) {
      setVaultBuffer(2);
    } else if (width < 1352) {
      setVaultBuffer(3);
    } else {
      setVaultBuffer(4);
    }
  }, [width]);

  useEffect(() => {
    if (props.user) {
      props.toggleLoading(true);
      routes.getVaults().subscribe((response) => {

        const vaults = response.data.map((vault) => {
          // format vault dates & display values
          vault['lastUpdated'] = moment(vault.updated).format('MM-DD-YYYY');
          vault['purposeDisplay'] = purposeMapping[vault['purpose']];

          _.forEach(vault["activity_log"], (activity) => {
            activity.vaultName = vault.vault_name;
            activity.vaultId = vault.id;
          });

          return vault;
        });

        setVaults(_.orderBy(vaults, (vault) => moment(vault.updated), ['desc']));
        setActivityLog(_.orderBy(_.flatten(_.map(vaults, 'activity_log')), (x) => moment(x.created), ['desc']));
        props.toggleLoading(false);
      });
    }
  }, [props.user]);

  const otherVaults = _.filter(vaults, vault => vault.role !== OWNER && (showOtherArchived || vault.status !== 'ARCHIVED'));
  const ownerVaults = _.filter(vaults, vault => vault.role === OWNER && (showOwnerArchived || vault.status !== 'ARCHIVED'));
  const numOwnerArchived = _.filter(vaults, vault => vault.role === OWNER && vault.status === 'ARCHIVED').length;
  const numOtherArchived = _.filter(vaults, vault => vault.role !== OWNER && vault.status === 'ARCHIVED').length;

  return (
    <div className="flex-1 dashboard">
      {
        vaults &&
        <div className="full-size dashboard-container mx-auto">
          <DashboardBanner user={props.user}/>
          <div className="flex flex-col lg:flex-row justify-center">
            <div className="vaults-container lg:mr-8 mb-6 lg:mb-0">
              <Paper className="w-full">
                <div className="sm:flex sm:items-center">
                  <div className="vaults-description-container text-left">
                    <p className="medium-text">My Vaults</p>
                    <p className="text-grey text-sm mt-2">Vaults you own and manage</p>
                  </div>
                  <div className="vaults-top-divider mt-3 mb-5 sm:mt-0 sm:mb-0"/>
                  <div className="sm:ml-6">
                    <Button
                      variant="contained"
                      className="w-full sm:w-auto"
                      onClick={() => navigate(`/vaults/create/`)}
                      color="primary">
                      <span className="flex items-center">
                        <FontAwesomeIcon icon="plus" className="mr-2"/>
                        <p>Create New Vault</p>
                      </span>
                    </Button>
                    {
                      !!numOwnerArchived &&
                      <div className="flex items-center justify-end text-sm mt-4">
                        <span className="mr-2">Show Archived ({numOwnerArchived})</span>
                        <Checkbox
                          checked={showOwnerArchived}
                          onChange={(event, checked) => setShowOwnerArchived(checked)}
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        />
                      </div>
                    }
                  </div>

                </div>

                {/*SHOW OWNER VAULTS*/}
                {
                  ownerVaults.length ?
                    <div className="flex items-center flex-wrap justify-around">
                      {_.map(ownerVaults, vault => <VaultCard key={vault.id} vault={vault}/>)}
                      {
                        !!((ownerVaults.length) % vaultBuffer) &&
                        _.map(new Array( vaultBuffer - (ownerVaults.length) % vaultBuffer), (i) => {
                          return <div key={i} className="empty-vault-card"/>
                        })
                      }
                    </div>
                    :
                    <div className="flex items-center text-center justify-center missing-other-vaults">
                      <div className="mt-3">
                        <p className="text-grey text-xl">No Vaults Found.</p>
                        <p className="text-grey text-sm mt-3 md:text-base">New to Fidelius? View our <a target="_blank" href={"https://www.fideliusvaults.com/faq/"}>FAQ</a> and <a target="_blank" href={"https://www.fideliusvaults.com/how-it-works/"}>How It Works</a> pages for more information.</p>
                      </div>
                    </div>
                }

                {/*SHOW OTHER VAULTS*/}
                <div className="sm:flex sm:items-center mt-12">
                  <div className="vaults-description-container text-left">
                    <p className="medium-text">Other Vaults</p>
                    <p className="text-grey text-sm mt-2">Vaults you can access and view</p>
                  </div>
                  <div className="vaults-top-divider my-3 sm:my-0"/>
                  {
                    !!numOtherArchived &&
                    <div className="flex items-center justify-end sm:ml-6 text-sm">
                      Show Archived ({ numOtherArchived })
                      <Checkbox
                        checked={showOtherArchived}
                        onChange={(event, checked) => setShowOtherArchived(checked)}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                      />
                    </div>
                  }
                </div>
                {
                  otherVaults.length ?
                    <div className="flex items-center flex-wrap justify-around">
                      {
                        _.map(otherVaults, vault => <VaultCard key={vault.id} vault={vault}/>)
                      }
                      {
                        !!((otherVaults.length) % vaultBuffer) &&
                        _.map(new Array( vaultBuffer - (otherVaults.length) % vaultBuffer), (i) => {
                          return <div className="empty-vault-card mx-2"/>
                        })
                      }
                    </div>
                    :
                    <div className="flex items-center text-center justify-center missing-other-vaults">
                      {
                        props.user.emailVerified ?
                          <span className="text-grey text-xl mt-3">No Vaults Found.</span>
                          :
                          <span className="text-grey text-xl mt-3">You must <a onClick={() => navigate("/email-confirmation")}>verify your email</a> before viewing other vaults.</span>
                      }
                    </div>
                }
              </Paper>
            </div>

            <div className="dashboard-sidebar-container">
              <FreeTrialCard user={props.user} toggleAccountPreferencesModal={props.toggleAccountPreferencesModal}/>
              <ActivityLog activityLog={activityLog}/>
            </div>
          </div>

        </div>
      }
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    user: state.user.user,
  };
};

export default compose(
  connect(
    mapStateToProps,
    { toggleLoading, toggleAccountPreferencesModal }
  )
)(Dashboard);
